import axios from "axios";
import { environment } from "../environments/environment";

export const dropdownConfig = (dropDowndId) => { // return config of dropdowns
    let param = new URLSearchParams();
    param.append("dropdownId", dropDowndId.toString())

    return axios.get(environment.getDropDownConfig + param);
}

export const getDropdownData = (dropDowndId, searchTerm = "", dependency, page = 0, pageSize = 10, parentComponentId, filters, parameters) => { // return the data that is showed in the dropdowns
    const data = {
        id: dropDowndId,
        search: searchTerm || "",
        dependencies: dependency,
        page: page,
        pageSize: pageSize,
        parentComponentId: parentComponentId,
        filters: filters,
        parameters: parameters
    }

    return axios.post(environment.getDropdownData, data);
}